const cropChecklists = [
    {
        "category": "01",
        "text": "1.基本資料",
        "display": "基本資料",
        "opinionAndSuggestion": "",
        "items": [
            {
                "code": "01-1",
                "text": "1.1 申請人之身分證字號等資訊，與申請書相同?(初次申請或申請人異動時適用)"
            },
            {
                "code": "01-2",
                "text": "1.2 檢查過程中有瞭解此農場運作人員陪同?何人(姓名，職稱)"
            },
            {
                "code": "01-3",
                "text": "1.3 農場過去曾經申請其他有機驗證機構驗證嗎? 如有，請列何驗證機構及申請結果"
            },
            {
                "code": "01-4",
                "text": "1.4 是否同時具有通過其他家驗證公司驗證田區? 如是，是否有相同作物?請列出。"
            },
            {
                "code": "01-5",
                "text": "1.5 驗證產品相關業務若有非申請人(或授權代表)本人自行操作項目是否如申請書所述？若有異動，請說明(並請申請人於申請文件一併修正)"
            },
            {
                "code": "01-6",
                "text": "1.6 經驗證或未驗證之農產品會經由加工（含自產農產加工）後銷售嗎?"
            },
            {
                "code": "01-7",
                "text": "1.7 是否執行”下次查驗重點”，並完成改善？如“否”，請說明原因。(改善比例約_%)"
            },
            {
                "code": "01-8",
                "text": "1.8 農場圖是否正確?(集團驗證需核對農場圖總圖及各個田區農場圖)"
            },
            {
                "code": "01-9",
                "text": "1.9 現場檢查時，所種植及販售之作物是否與驗證證書品項一致? 如否，請列出未列入驗證品項之作物"
            },
        ]
    },
    {
        "category": "02",
        "text": "2.生產環境條件",
        "display": "生產環境條件",
        "opinionAndSuggestion": "請提供關於「生產環境條件」的看法與建議：\n" +
            "說明:",
        "items": [
            {
                "code": "02-1",
                "text": "2.1 申請驗證之生產地是否具有所有權或經營使用權?"
            },
            {
                "code": "02-2",
                "text": "2.2 申請驗證之生產範圍是否有明確、有固定之界線?"
            },
            {
                "code": "02-3",
                "text": "2.3 生產區是否採取明確和適當的水土保持措施以防止土壤流失?"
            },
            {
                "code": "02-4",
                "text": "2.4 有機生產區附近是否無污染源，如工礦區、垃圾場、慣行生產區或鄰地的路邊（驗證田區外）未有禁用資材控制雜草與病蟲害的跡象?"
            },
            {
                "code": "02-5",
                "text": "2.5 有機生產區與慣行生產區的灌溉排水系統是否確保慣行農田的水不會滲透或漫入有機生產區?"
            },
        ]
    },
    {
        "category": "03",
        "text": "3.緩衝帶",
        "display": "緩衝帶",
        "opinionAndSuggestion": "請提供其他「阻絶污染、緩衝帶或障礙物」的看法與建議：\n" +
            "說明:",
        "items": [
            {
                "code": "03-1",
                "text": "3.1 當有機生產區緊臨慣行生產、公路等污染源時，是否在有機生產區設立足以阻絶污染的緩衝帶或障礙物，以防止有機生產區受污染?"
            },
            {
                "code": "03-2",
                "text": "3.2 緩衝帶如種植可利用作物時，不以有機農產品名義出售?"
            },
            {
                "code": "03-3",
                "text": "3.3 緩衝帶作物如與生產區內作物相同，是否提出管理紀錄?"
            },
            {
                "code": "03-4",
                "text": "3.4 緩衝帶現場是否有清楚的標示措施?"
            },
        ]
    },
    {
        "category": "04",
        "text": "4.有機轉型期",
        "display": "有機轉型期",
        "opinionAndSuggestion": "請提供縮短「有機轉型期」證明的看法與建議： ",
        "items": [
            {
                "code": "04-1",
                "text": "4.1 是否提供縮短轉型期相關佐證資料?請說明所附文件"
            }
        ]
    },
    {
        "category": "05",
        "text": "5.平行生產",
        "display": "平行生產",
        "opinionAndSuggestion": "請提供其他「平行生產」的看法與建議:\n" +
            "說明:",
        "items": [
            {
                "code": "05-1",
                "text": "5.1 平行生產時，在生產、採收、貯藏、運輸、銷售和加工過程中，是否將驗證作物與其他作物清楚地分開且標示?顯示有機與非有機之作業方式，避免混淆和遭受污染的風險"
            },
            {
                "code": "05-2",
                "text": "5.2 作物相似或相同者，是否已有完整的紀錄作追溯稽核?"
            },
            {
                "code": "05-3",
                "text": "5.3 非有機允用資材是否隔離置放，且標示清楚?"
            },
        ]
    },
    {
        "category": "06",
        "text": "6.作物繁殖資料",
        "display": "作物繁殖資料",
        "opinionAndSuggestion": "請提供其他「作物繁殖材料」的看法與建議:\n" +
            "說明:",
        "items": [
            {
                "code": "06-1",
                "text": "6.1 食用芽菜或苗菜是否使用有機種子生產?"
            },
            {
                "code": "06-2",
                "text": "6.2 作物繁殖材料為有機或不以合成化學物質、對人體有害之植物性萃取物或礦物性材料處理? (依農委會基準得使用合成化學物質處理者，不在此限。)"
            },
            {
                "code": "06-3",
                "text": "6.3 種子(如黃豆、玉米(筍)、甜菜、油菜、棉花)及種苗(如木瓜)不使用任何經基因改造?"
            },
            {
                "code": "06-4",
                "text": "6.4 若採用經化學藥劑處理之作物繁殖材料者，是否提送使用計畫，並經驗證機構審查確認合格繁殖材料無法取得? (依農委會基準得使用合成化學物質處理者，不在此限。)"
            },
        ]
    },
    {
        "category": "07",
        "text": "7.病蟲草害管理",
        "display": "病蟲草害管理",
        "opinionAndSuggestion": "請提供關於「病蟲草害管理」的看法與建議：\n" +
            "說明:",
        "items": [
            {
                "code": "07-1",
                "text": "7.1 是否採行預防措施、輪作、間作、敷蓋、覆蓋、人工或機械耕犁、斷水、湛水控制、飼養禽畜及其他物理或生物防治等方式，適度控制雜草之發生?(如是，請簡要敘述控制方法)"
            },
            {
                "code": "07-2",
                "text": "7.2 是否以密植撒播、移植、選留適合之自生性雜草或以人工種植草類，保持土表呈草生狀態?"
            },
            {
                "code": "07-3",
                "text": "7.3 選擇保護性的敷蓋物、塑膠薄膜、防蟲網和包裝材料時，是否只使用允許之聚乙烯（PE）、聚丙烯(PP)或聚碳酸酯基(PC)等產品敷蓋，並在使用後完整清除且禁止在田地上焚燒?"
            },
            {
                "code": "07-4",
                "text": "7.4 是否採輪作及其他耕作防治如種植忌避或共榮植物或物理防治、生物防治、等綜合防治法，以防病蟲害發生?"
            },
            {
                "code": "07-5",
                "text": "7.5 是否適當管理及保育天敵的棲息地(例如：種植綠籬、防風林，設置巢居地和生態緩衝帶)?"
            },
            {
                "code": "07-6",
                "text": "7.6 未使用合成化學物質(除草劑、殺菌劑、殺蟲劑、生長調節)及殘留農藥、輻射性物質或過量重金屬之作物殘渣及生物資材與聚氯乙烯(PVC)或對人體有害之植物性萃取物與礦物性材料?"
            },
            {
                "code": "07-7",
                "text": "7.7 自農場外取得、商品化或有條件使用(如含毒甲基丁香油)之防治資材是否已於申請書提報或經驗證機構審查同意?"
            },
            {
                "code": "07-8",
                "text": "7.8 因應政府辦理整體防疫防治工作，而必須使用第二章二(一)以外之合成化學物質者，農產品經營者有事先通知驗證機構相關施作範圍、藥劑、方式等，並由驗證機構判定管制範圍及管制期間，於管制期間該管制範圍內之產品不以有機名義販售?"
            },
            {
                "code": "07-9",
                "text": "7.9 病蟲草害防治技術及資材是否符合農委會有機相關法規之規定?"
            },
        ]
    },
    {
        "category": "08",
        "text": "8.土壤培育",
        "display": "土壤培育",
        "opinionAndSuggestion": "請提供關於「土壤培育」的看法與建議：\n" +
            "說明:",
        "items": [
            {
                "code": "08-1",
                "text": "8.1 是否採取土樣分析，以瞭解土壤理化性及肥力狀況，作為土壤肥培管理之依據?(初次申請、展延查驗及增列農地時適用)"
            },
            {
                "code": "08-2",
                "text": "8.2 是否採取適當輪作、間作或適時休耕、植物敷蓋(綠肥)、就地翻耕等，以維護區域內生物多樣性，保持土壤肥力?"
            },
            {
                "code": "08-3",
                "text": "8.3 農場內資源優先循環利用，自農場外取得、商品化有機質肥料或是否已於申請書提報或經驗證機構審查同意"
            },
            {
                "code": "08-4",
                "text": "8.4 是否未直接使用人及家畜禽糞尿，必須使用家禽畜糞時，經充分腐熟處理?"
            },
            {
                "code": "08-5",
                "text": "8.5 使用微量元素時，是否已提出缺乏微量元素證明及使用計畫經驗證機構審查認可?"
            },
            {
                "code": "08-6",
                "text": "8.6 使用礦物性肥料或微生物資材時以天然成分之型態時，並未經化學處理或添加以提高其有效性?"
            },
            {
                "code": "08-7",
                "text": "8.7 不焚燒生產區及植株殘體，以防止土壤微生物相的破壞及污染空氣?"
            },
            {
                "code": "08-8",
                "text": "8.8 土壤肥力改良方法及資材是否符合農委會有機相關法規之規定?"
            },
        ]
    },
    {
        "category": "09",
        "text": "9.有機完整性",
        "display": "有機完整性",
        "opinionAndSuggestion": "",
        "items": [
            {
                "code": "09-1",
                "text": "9.1 使用所有回收再利用之容器前是否徹底清潔?"
            },
            {
                "code": "09-2",
                "text": "9.2 容器、包裝區、貯藏區未使用禁用資材清潔?"
            },
            {
                "code": "09-3",
                "text": "9.3 當有機產品與非有機產品一同運輸，或產品存放於同一倉庫內時，是否將有機產品妥善包裝或區隔，並清楚標示，確保有機產品不會與非有機產品混雜?"
            },
            {
                "code": "09-4",
                "text": "9.4 生產區及生產設備、貯藏區，是否維持整潔衛生，避免環境污染?"
            },
            {
                "code": "09-5",
                "text": "9.5 農具、機械及運輸設備，使用於非有機之田區或作物後，用於有機生產是否徹底清除殘留物?"
            },
            {
                "code": "09-6",
                "text": "9.6 所有的設備是否都經良好的維護，且不會因污染而影響到有機作物及農地(因機油、燃料或冷卻劑的滲漏)?"
            },
            {
                "code": "09-7",
                "text": "9.7 作物銷售是否有使用標章?(勾是，請續說明8.8及8.9)"
            },
            {
                "code": "09-8",
                "text": "9.8 是否正確使用有機、有機轉型期之標章?並列出庫存標章流水號"
            },
        ]
    },
    {
        "category": "10",
        "text": "10.建立文件",
        "display": "建立文件",
        "opinionAndSuggestion": "請提供其他「建立文件」的看法與建議：\n" +
            "說明:",
        "items": [
            {
                "code": "10-1",
                "text": "10.1 田間作業日誌是否包括：投入農場內所有資材來源、田間作業管理、種植、採收和運輸的全部過程紀錄?"
            },
            {
                "code": "10-2",
                "text": "10.2 a.是否建立貯藏紀錄? b.其所含項目是否能有效溯及採收、銷售紀錄內 之資訊內容?"
            },
            {
                "code": "10-3",
                "text": "10.3 a.是否建立銷售紀錄? b.其所含項目是否能有效溯及採收、貯藏紀錄內之資訊內容?"
            },
            {
                "code": "10-4",
                "text": "10.4 保存採購資材收據、出貨單、過磅單及所有種子、種苗來源（含非基改證明）、證明或採購等相關單據?"
            },
            {
                "code": "10-5",
                "text": "10.5 緩衝帶作物若有採收、銷售，是否建立採收、銷售紀錄?"
            },
            {
                "code": "10-6",
                "text": "10.6 生產田區如遭慣行鄰田噴藥污染，是否執行鄰田噴藥觀察紀錄，及防範措施紀錄，以掌控可能污染來源之跡證?"
            },
            {
                "code": "10-7",
                "text": "10.7 經使用的農具、機械及運輸設備如有清潔，是否維持清潔紀錄?"
            },
            {
                "code": "10-8",
                "text": "10.8 保存所有買方抱怨、申訴及其矯正措施之紀錄及相關處理程序文件說明?並對產品之召回處理是否作成紀錄以供查核?"
            },
            {
                "code": "10-9",
                "text": "10.9 有機農產品各項紀錄保存:生鮮農產品一年；但驗證產品標示有效日期者，至少保存至有效日期屆滿後一年為止?(其他產品五年)"
            },
        ]
    },
    {
        "category": "11",
        "text": "11.包裝",
        "display": "包裝",
        "opinionAndSuggestion": "",
        "items": [
            {
                "code": "11-1",
                "text": "11.1 包裝方法及材料是否以簡單為原則，避免過度包裝? 且在未打開或破壞封條之前無法更換產品內容?"
            },
            {
                "code": "11-2",
                "text": "11.2 是否採用可生物降解、可循環再利用或再製之包裝材料。但上述包裝材料無法取得或不適用時，始得使用一般之包裝材料?"
            },
            {
                "code": "11-3",
                "text": "11.3 是否無使用含有禁用物質之包裝材料及其他會污染產品之包裝材料?"
            },
            {
                "code": "11-4",
                "text": "11.4 是否儘量使用對人體無害之印刷油墨及黏著劑，且避免與產品直接接觸?"
            },
            {
                "code": "11-5",
                "text": "11.5 包裝材料儲存是否保持清潔及衛生，避免產品受非有機允用物質污染?"
            }
        ]
    },
]

export default cropChecklists